// extracted by mini-css-extract-plugin
export default {"icon":"ErrorMolecule_icon__Ag1ov","iconWrapper":"ErrorMolecule_iconWrapper__L1jJ4","textWrapper":"ErrorMolecule_textWrapper__3x5cr"};